export const DEFAULT_BACKGROUND_WIDTH = 1920;
export const DEFAULT_FORM_SELECTOR_BACKGROUND_WIDTH = 1000;

export default {};
